import { useEffect, useRef } from 'react';
import type { PlayerProfile, SlotDemoScene } from '@goodtime/engine';
import { claimLocally, computePreviewStreak, REWARD_FOR_DAY } from './dailyBonus';

export interface SlotDailyBonusProps {
  scene: SlotDemoScene;
  profile: PlayerProfile;
  /** Claims on the server wallet; without it the local profile claims. */
  onClaim?: () => Promise<{ reward: number; streak: number } | null>;
  /** The board has closed. */
  onDone: () => void;
}

/**
 * The daily bonus over the slot: the slot shows it on its own canvas, on a
 * board (producer 2026-10-14: everything in the game is drawn in Pixi), in
 * place of the DOM card the other screens show. Renders nothing itself.
 */
export function SlotDailyBonus({ scene, profile, onClaim, onDone }: SlotDailyBonusProps) {
  const started = useRef(false);
  const latest = useRef({ onClaim, onDone });
  latest.current = { onClaim, onDone };
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    void scene
      .playDailyBonus({
        today: computePreviewStreak(profile),
        rewardFor: REWARD_FOR_DAY,
        claim: () => (latest.current.onClaim ? latest.current.onClaim() : Promise.resolve(claimLocally(profile))),
      })
      .then(() => latest.current.onDone());
  }, [scene, profile]);
  return null;
}
